import { ActionKeys } from '~/actions/constants';
import * as providersActions from '~/actions/providers.actions';
import * as shipmentsActions from '~/actions/shipments.actions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getAllServiceLevels } from '~/services/providers.service';
import ProviderAccount, { fromJSON } from '~/types/ProviderAccount';

export function* fetchServiceLevelsByAccount() {
  try {
    const response = yield call(getAllServiceLevels);
    const accounts: ProviderAccount[] = fromJSON(response.data?.results ?? []);

    yield put(providersActions.fetchServiceLevelsByAccountSuccess(accounts));

    // trigger autoSelecting rates, in case the shipments were fetched before service levels were available
    yield put(shipmentsActions.retryAutoSelectRates());
  } catch (err) {
    yield put(
      providersActions.fetchServiceLevelsByAccountError(
        'settings:automations:serviceLevelRetrievalError',
      ),
    );
  }
}

export default [takeEvery(ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT, fetchServiceLevelsByAccount)];
